import { IFileItem } from 'app/models/responses/IFileItem';
import { rootConfig } from 'config';

const getFileUrl = (file: IFileItem) => {
  return `${rootConfig.apiRoute}/files/${file.guid}${file.extension}`;
};

export default getFileUrl;
